import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class ReadonlyBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.readonly = {
            update: (element: HTMLInputElement, valueAccessor: () => any) => {
                let value = ko.utils.unwrapObservable(valueAccessor());
                if (!value && element.readOnly)
                    element.readOnly = false;
                else if (value && !element.readOnly)
                    element.readOnly = true;
            }
        };
    }
}